<input [id]="id"
       [ngbTooltip]="tooltip?.enable ? control?.value?.name: null"
       type="text"
       class="form-control"
       [placeholder]="placeholder"
       #typeahead="ngbTypeahead"
       #typeaheadTooltip="ngbTooltip"
       [formControl]="control"
       [ngbTypeahead]="search"
       [editable]="editable"
       [inputFormatter]="inputFormatter || formatter"
       [resultFormatter]="formatter"
       (focus)="focus$.next($event.target.value)"
       (blur)="onBlur()" />
